import {Injectable} from '@angular/core';
import {DaoGeneric} from '@Services/base/daoService';
import {environment} from '@Env/environment';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {GestionnaireDemat} from './gestionnaire.model';

@Injectable({
  providedIn: 'root'
})
export class GestionnairesService extends DaoGeneric<GestionnaireDemat> {
  private url = `${environment.baseUrl}/demat/gestionnaires/`;

  constructor(private httpClient: HttpClient) {
    super(httpClient);
  }

  getRootUrl(): string {
    return this.url;
  }

  /**
   * Recherche de gestionnaires (search=xyz&role=gestionnaire_role)
   * @param val la chaine de recherche (prénom nom)
   * @return une liste Gestionnaire (RoleEntite) trouvés
   */
  searchGestionnaire(val): Observable<GestionnaireDemat[]> {
    let urlQS = new HttpParams();
    urlQS = urlQS.set('search', val);

    return this.httpClient.get<GestionnaireDemat[]>(this.url, {params: urlQS});
  }

  /**
   * Un gestionnaire d'un formulaire
   * @param formUUID
   * @param userId
   */
  gestionnaireFormulaire(formUUID, userId): Observable<GestionnaireDemat[]> {
    const url = `${this.url}gestionnaire_formulaire/`;
    let urlQS = new HttpParams();
    urlQS = urlQS.set('user', userId).set('form_uuid', formUUID);
    return this.httpClient.get<GestionnaireDemat[]>(url, {params: urlQS});
  }

  /**
   * Tous les gestionnaires d'un formulaire
   * @param formUUID
   */
  gestionnairesFormulaire(formUUID): Observable<GestionnaireDemat[]> {
    const url = `${this.url}gestionnaire_formulaire/`;
    let urlQS = new HttpParams();
    urlQS = urlQS.set('form_uuid', formUUID);
    return this.httpClient.get<GestionnaireDemat[]>(url, {params: urlQS});
  }
}
